"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _setDisplayName = _interopRequireDefault(require("recompose/setDisplayName"));

var _props = require("./props");

var _enhance = _interopRequireDefault(require("./enhance"));

var _PieLayout = _interopRequireDefault(require("./PieLayout"));

var _PieCanvasRenderer = _interopRequireDefault(require("./PieCanvasRenderer"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

class PieCanvas extends _react.Component {
  render() {
    const _this$props = this.props,
          data = _this$props.data,
          sortByValue = _this$props.sortByValue,
          startAngle = _this$props.startAngle,
          endAngle = _this$props.endAngle,
          fit = _this$props.fit,
          padAngle = _this$props.padAngle,
          innerRadius = _this$props.innerRadius,
          cornerRadius = _this$props.cornerRadius,
          width = _this$props.width,
          height = _this$props.height,
          colors = _this$props.colors,
          colorBy = _this$props.colorBy,
          topProps = _objectWithoutPropertiesLoose(_this$props, ["data", "sortByValue", "startAngle", "endAngle", "fit", "padAngle", "innerRadius", "cornerRadius", "width", "height", "colors", "colorBy"]);

    return _react.default.createElement(_PieLayout.default, {
      width: width,
      height: height,
      data: data,
      sortByValue: sortByValue,
      startAngle: startAngle,
      endAngle: endAngle,
      fit: fit,
      padAngle: padAngle,
      innerRadius: innerRadius,
      cornerRadius: cornerRadius,
      colors: colors,
      colorBy: colorBy
    }, props => _react.default.createElement(_PieCanvasRenderer.default, _extends({}, topProps, props)));
  }

}

PieCanvas.propTypes = process.env.NODE_ENV !== "production" ? _props.PiePropTypes : {};

var _default = (0, _setDisplayName.default)('PieCanvas')((0, _enhance.default)(PieCanvas));

exports.default = _default;
module.exports = exports.default;